// Canonical business-date helpers — Asia/Jakarta (WIB, UTC+7).
// Never derive the business "today" from browser-local `new Date()` parts.
// All functions operate on YYYY-MM-DD strings in WIB.

// Today's WIB calendar date as YYYY-MM-DD (independent of the browser timezone).
export const wibToday = () =>
  new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Jakarta" }).format(new Date());

// Shift a YYYY-MM-DD string by n days (calendar-safe, UTC math on the date only).
export const addDays = (ds, n) => {
  const [y, m, d] = ds.split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  dt.setUTCDate(dt.getUTCDate() + n);
  return dt.toISOString().slice(0, 10);
};

export const firstOfMonth = (ds) => ds.slice(0, 8) + "01";
export const firstOfYear = (ds) => ds.slice(0, 4) + "-01-01";

// WIB day start/end as UTC ISO (+00:00) for sending to timestamp-filtered APIs.
const WIB_MIN = 7 * 60;
const toParam = (dt) => dt.toISOString().replace("Z", "+00:00");
export const wibStartUTC = (ds) => {
  const [y, m, d] = ds.split("-").map(Number);
  return toParam(new Date(Date.UTC(y, m - 1, d, 0, 0, 0) - WIB_MIN * 60000));
};
export const wibEndUTC = (ds) => {
  const [y, m, d] = ds.split("-").map(Number);
  return toParam(new Date(Date.UTC(y, m - 1, d, 23, 59, 59, 999) - WIB_MIN * 60000));
};

// Format a stored ISO timestamp in WIB for display.
export const fmtWib = (iso) =>
  iso
    ? new Intl.DateTimeFormat("id-ID", {
        timeZone: "Asia/Jakarta", day: "2-digit", month: "short", year: "numeric",
        hour: "2-digit", minute: "2-digit",
      }).format(new Date(iso)).replace(/\./g, ":")
    : "-";
